<script>
import { onMount } from "svelte";

    onMount(() => {
        (function(f,o,r,m){
            // Donorflow Forms v1.2 2021
    		let dt=Date.now();m=f.createElement(o);m.src=r+"forms.js?v="+dt;f.body.appendChild(m);
   		})(document,'script','https://s.donorflow.net/');
    });
</script>
<div class="contactblock">
    <h2 id="contact" class="text-center" style="color: white !important;">Contact</h2>
    <div class="contactform">
        <p class="text-center white bold">If you have questions or want to get in contact with the filmmakers please write to us here:</p>
        <div style="max-width:400px;margin: 0 auto;display:flex;justify-content:center;">
            <div id="dfform" data-form="11"></div>
        </div>
    </div>
</div>

<style>
    #dfform {
        width: 100%;
        display: flex;
        justify-content:center;
    }
    #dfform label {
        font-size: 1.4rem !important;
    }
    .contactblock {
        background: #b4b4b4;
        padding: 2rem 1rem;
        margin-bottom: 3rem;
    }
</style>